export default {"src":"/_next/static/media/introduction-circular-icon.911a932e.svg","height":138,"width":138,"blurWidth":0,"blurHeight":0};